import * as React from "react"
import UnauthorizedLayout from "../../components/layouts/UnauthorizedLayout"
import PasswordResetRequestComponent from "../../components/screens/passwordResetRequest/PasswordResetRequestComponent"
import Head from "next/head"

const passwordResetRequestPage = () => {
    return (
        <>
            <Head>
                <title>Request Password Reset - Figure Manage</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Head>
            <UnauthorizedLayout>
                <PasswordResetRequestComponent />
            </UnauthorizedLayout>
        </>
    )
}

export default passwordResetRequestPage
